<form [formGroup]="form" (submit)="getRsolutionGridDetails()">
    <div class="row">
        <div class="col-12">
            <h5>{{resolutionInputModel.DateRangeLabel}}</h5>
            <label class="mr-4">
                <input type="text" name="StartDate" id="StartDate" formControlName="StartDate" class="form-control" datepicker (change)="onCalenderchange($event)"/>
                <h6 class="pt-2" style="color:grey">{{resolutionInputModel.StartDateLabel}}</h6>
            </label>
            <label>
                <input type="text" name="EndDate" id="EndDate" formControlName="EndDate" class="form-control" datepicker (change)="onCalenderchange($event)" />
                <h6 class="pt-2" style="color:grey">{{resolutionInputModel.EndDateLabel}}</h6>
            </label>
            <h6 class="text-secondary" *ngIf="!isValidDate">{{dateErrorMessage}}</h6>
        </div>
        <div class="col-12">
            <label>
                <h5>
                    {{resolutionInputModel.KeywordLabel}}
                </h5>
                <input type="text" formControlName="Keyword" class="form-control w-100" />
            </label>
        </div>
        <div class="col-12">
            <label>
                <h5>
                    {{resolutionInputModel.IdLabel}}
                </h5>
                <input type="text" formControlName="Id" class="form-control w-100" />
            </label>
        </div>

        <h5 class="col-12 pt-3">{{resolutionInputModel.StatusLabel}}</h5>
        <div class="col-12 col-md-6">
            <ng-multiselect-dropdown [placeholder]="'Select'"
                                     [settings]="dropdownSettings"
                                     [data]="resolutionInputModel.ResolutionStatuses"
                                     formControlName="ResolutionStatuses"
                                     [(ngModel)]="SelectedResolutions">
            </ng-multiselect-dropdown>
        </div>

        <div class="col-12 pt-3">
            <div class="row pl-3">
                <button type="submit" class="btn btn-primary btn-md col-xs-3" [disabled]="!isValidDate">Apply</button>
                <span class="text-secondary col-9 my-auto" *ngIf="!isRequired">{{resolutionInputModel.ValidationMessage}}</span>
            </div>
        </div>

        <div class="col-12 pt-3">
            <ag-grid-angular id="resolutionGrid" class="ag-theme-alpine"
                             [columnDefs]="columnDefs"
                             [defaultColDef]="defaultColDef"
                             [rowData]="rowData"
                             [domLayout]="domLayout"
                             [pagination]="pagination"
                             [paginationPageSize]="paginationPageSize"
                             (gridReady)="onGridReady($event)"
                             [overlayLoadingTemplate]="loadingTemplate"
                             [overlayNoRowsTemplate]="noRowsTemplate"
                             [suppressColumnMoveAnimation]="false">
            </ag-grid-angular>

        </div>
        <div *ngFor="let s of sizes" class="{{s.css + ' ' + (prefix + s.id) }}"></div>
    </div>
</form>